import React from 'react';

export const NavbarSidemenuDivider = () => (
    <hr className="NavbarSidemenu__divider" />
);
